
import { movementsApi } from "./movementsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProductsMovements, CreateProductsMovements, AdjustmentReason, MovementsRequest } from "./movements.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchProductsMovements = createAsyncThunk<
  APIResponse<{page: number; size: number; total: number; totalPages: number; movimientos: ProductsMovements[]}>,
  MovementsRequest,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/fetchProductsMovements',
  async ( params, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        movementsApi.endpoints.getProductsMovements.initiate(params)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener movimientos de stock',
          details: data.details
        });
    }
  }
);


export const createProductMovements = createAsyncThunk<APIResponse<ProductsMovements>, CreateProductsMovements,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/createProductMovements',
  async (data: CreateProductsMovements, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        movementsApi.endpoints.createProductsMovements.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Producto',
        details: data.details
      });
    }
  }
);




export const fetchAdjustmentReasons = createAsyncThunk<
  APIResponse<AdjustmentReason[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/fetchAdjustmentReasons',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        movementsApi.endpoints.getAdjustmentsReasons.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener productos con ubicaciones',
          details: data.details
        });
    }
  }
);
